module.exports = __webpack_public_path__ + "img/letter-logo-white.9fb3eae7.svg";